import { Component, Input, OnInit } from '@angular/core';
import { StoreService } from '@ddt-web/store-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';
import { combineLatest } from 'rxjs';
import { first } from 'rxjs/operators';

import { ModelsBrowseStoreConfig } from '../../config/store.config';
import { ModelPortfolio } from '../../models';
import { ModelsBrowseDataService } from '../../services/models-browse-data.service';
import { FamiliesUtil } from '../../utils';

@UntilDestroy()
@Component({
	selector: 'mb-inception-date',
	templateUrl: './family-inception-date.component.html',
	styleUrls: ['./family-inception-date.component.scss']
})
export class FamilyInceptionDateComponent implements OnInit {

	@Input() public familyId: string;
	@Input() public groupId: string;

	public inceptionDateText: string;

	constructor(
		private modelsBrowseDataService: ModelsBrowseDataService,
		private storeService: StoreService
	) { }

	public ngOnInit(): void {
		combineLatest([
			this.storeService.selectById(ModelsBrowseStoreConfig.families, this.familyId), // used to retrieve model name
			this.storeService.selectAll(ModelsBrowseStoreConfig.familyHoldings) // used for inception date
		]).pipe(
			untilDestroyed(this),
			first(([families, familyHoldings]) => {
				return !isEmpty(get(families, this.familyId)) && (!familyHoldings.isLoading) && !isEmpty(familyHoldings.entities);
			})
		).subscribe(([families, familyHoldings]) => {
			const familyHoldingsData: Array<ModelPortfolio> = FamiliesUtil.getOrderedFamilyHoldingData(families, this.familyId, this.groupId, familyHoldings);
			this.inceptionDateText = this.modelsBrowseDataService.getInceptionDateText(families, familyHoldingsData, this.familyId);
		});
	}
}
